// Local translations
export const T = {
  en_GB: {
    fields: "Fields",
    fieldsDesc: "Choose which additional columns to display in the portfolio table.",
    isin: "ISIN",
    isinDesc: "Show the ISIN column in the table",
    productType: "Product Type",
    productTypeDesc: "Show the product type column in the table",
  },
  nb_NO: {
    fields: "Felter",
    fieldsDesc: "Velg hvilke tilleggskolonner som skal vises i porteføljetabellen.",
    isin: "ISIN",
    isinDesc: "Vis ISIN-kolonnen i tabellen",
    productType: "Produkttype",
    productTypeDesc: "Vis produkttype-kolonnen i tabellen",
  },
} as const;
